import { render } from "./InfiniteLoadingList.vue?vue&type=template&id=70afe75c&scoped=true"
import script from "./InfiniteLoadingList.vue?vue&type=script&lang=js"
export * from "./InfiniteLoadingList.vue?vue&type=script&lang=js"

import "./InfiniteLoadingList.vue?vue&type=style&index=0&id=70afe75c&lang=scss&scoped=true"

import exportComponent from "/Users/icesea/WebstormProjects/fpcs-h5/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70afe75c"]])

export default __exports__